"use client";

import { c as _c } from "react/compiler-runtime";
import { useLinkPreviewVariant } from "./LinkPreviewContext";
import { LinkPreviewCardLayout } from "./OpenGraphPreview";
import MarketplaceCompactCta from "./marketplace/MarketplaceCompactCta";
import MarketplaceFullFooter from "./marketplace/MarketplaceFullFooter";
import MarketplaceItemPreviewMediaLink from "./marketplace/MarketplaceItemPreviewMediaLink";
import { DEFAULT_MARKETPLACE_TITLE } from "./marketplace/MarketplaceItemPreviewCard.constants";
import type { MarketplaceItemPreviewCardProps } from "./marketplace/MarketplaceItemPreviewCard.types";
import { buildMarketplaceCtaLabel, getMarketplaceBrand, resolvePreviewHref } from "./marketplace/MarketplaceItemPreviewCard.utils";
import MarketplaceOverlayActionButtons from "./marketplace/MarketplaceOverlayActionButtons";
import { getMarketplaceContainerClass } from "./marketplace/previewLayout";
const normalizeSpaceSeparatedText = (value: string): string => value.trim().replace(/\s+/g, " ");
const buildDisplayPriceParts = ({
  price,
  priceCurrency
}: {
  readonly price: string;
  readonly priceCurrency: string;
}) => {
  if (price.length === 0) {
    return {
      priceValueText: "",
      priceCurrencyText: "",
      ariaPriceText: ""
    };
  }
  let priceValueText = price;
  if (priceCurrency.length > 0) {
    const tokens = price.split(" ");
    const lastToken = tokens[tokens.length - 1];
    if (typeof lastToken === "string" && tokens.length > 1 && lastToken.toUpperCase() === priceCurrency.toUpperCase()) {
      const strippedPrice = tokens.slice(0, -1).join(" ").trim();
      if (strippedPrice.length > 0) {
        priceValueText = strippedPrice;
      }
    }
  }
  const ariaPriceText = priceCurrency.length > 0 ? `${priceValueText} ${priceCurrency}` : priceValueText;
  return {
    priceValueText,
    priceCurrencyText: priceCurrency,
    ariaPriceText
  };
};
export default function MarketplaceItemPreviewCard(t0) {
  const $ = _c(67);
  const {
    href,
    mediaUrl,
    mediaMimeType,
    price,
    priceCurrency,
    title,
    compact: t1,
    hideActions: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const hideActions = t2 === undefined ? false : t2;
  const variant = useLinkPreviewVariant();
  let t3;
  if ($[0] !== href) {
    t3 = resolvePreviewHref(href);
    $[0] = href;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const resolvedPreviewHref = t3;
  let displayTitle;
  let hasPrice;
  let marketplaceBrand;
  let priceCurrencyText;
  let priceValueText;
  let t4;
  if ($[2] !== href || $[3] !== price || $[4] !== priceCurrency || $[5] !== title) {
    const normalizedPrice = typeof price === "string" ? normalizeSpaceSeparatedText(price) : "";
    const normalizedPriceCurrency = typeof priceCurrency === "string" ? normalizeSpaceSeparatedText(priceCurrency) : "";
    const {
      priceValueText: t5,
      priceCurrencyText: t6,
      ariaPriceText
    } = buildDisplayPriceParts({
      price: normalizedPrice,
      priceCurrency: normalizedPriceCurrency
    });
    priceValueText = t5;
    priceCurrencyText = t6;
    let t7;
    if ($[12] !== title) {
      t7 = typeof title === "string" ? title.trim() : "";
      $[12] = title;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const normalizedTitle = t7;
    hasPrice = priceValueText.length > 0;
    const hasTitle = normalizedTitle.length > 0;
    displayTitle = hasTitle ? normalizedTitle : DEFAULT_MARKETPLACE_TITLE;
    marketplaceBrand = getMarketplaceBrand(href);
    t4 = buildMarketplaceCtaLabel({
      normalizedPrice: ariaPriceText,
      marketplaceBrand
    });
    $[2] = href;
    $[3] = price;
    $[4] = priceCurrency;
    $[5] = title;
    $[6] = displayTitle;
    $[7] = hasPrice;
    $[8] = marketplaceBrand;
    $[9] = priceCurrencyText;
    $[10] = priceValueText;
    $[11] = t4;
  } else {
    displayTitle = $[6];
    hasPrice = $[7];
    marketplaceBrand = $[8];
    priceCurrencyText = $[9];
    priceValueText = $[10];
    t4 = $[11];
  }
  const ctaAriaLabel = t4;
  if (compact) {
    let t5;
    if ($[14] !== compact || $[15] !== variant) {
      t5 = getMarketplaceContainerClass(variant, compact);
      $[14] = compact;
      $[15] = variant;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    const t6 = `${t5} tw-relative`;
    let t7;
    if ($[17] !== mediaMimeType || $[18] !== mediaUrl || $[19] !== resolvedPreviewHref) {
      t7 = <MarketplaceItemPreviewMediaLink mediaMimeType={mediaMimeType} mediaUrl={mediaUrl} resolvedPreviewHref={resolvedPreviewHref} />;
      $[17] = mediaMimeType;
      $[18] = mediaUrl;
      $[19] = resolvedPreviewHref;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    const t8 = priceCurrencyText || undefined;
    let t9;
    if ($[21] !== ctaAriaLabel || $[22] !== hasPrice || $[23] !== hideActions || $[24] !== marketplaceBrand || $[25] !== priceValueText || $[26] !== resolvedPreviewHref || $[27] !== t8) {
      t9 = <MarketplaceCompactCta resolvedPreviewHref={resolvedPreviewHref} ctaAriaLabel={ctaAriaLabel} hideActions={hideActions} hasPrice={hasPrice} priceValueText={priceValueText} priceCurrencyText={t8} marketplaceBrand={marketplaceBrand} />;
      $[21] = ctaAriaLabel;
      $[22] = hasPrice;
      $[23] = hideActions;
      $[24] = marketplaceBrand;
      $[25] = priceValueText;
      $[26] = resolvedPreviewHref;
      $[27] = t8;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    let t10;
    if ($[29] !== hideActions || $[30] !== href || $[31] !== resolvedPreviewHref) {
      t10 = !hideActions && <MarketplaceOverlayActionButtons href={href} resolvedPreviewHref={resolvedPreviewHref} />;
      $[29] = hideActions;
      $[30] = href;
      $[31] = resolvedPreviewHref;
      $[32] = t10;
    } else {
      t10 = $[32];
    }
    let t11;
    if ($[33] !== t10 || $[34] !== t6 || $[35] !== t7 || $[36] !== t9) {
      t11 = <div className={t6} data-testid="manifold-item-card">{t7}{t9}{t10}</div>;
      $[33] = t10;
      $[34] = t6;
      $[35] = t7;
      $[36] = t9;
      $[37] = t11;
    } else {
      t11 = $[37];
    }
    let t12;
    if ($[38] !== href || $[39] !== t11 || $[40] !== variant) {
      t12 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t11}</LinkPreviewCardLayout>;
      $[38] = href;
      $[39] = t11;
      $[40] = variant;
      $[41] = t12;
    } else {
      t12 = $[41];
    }
    return t12;
  }
  let t5;
  if ($[42] !== compact || $[43] !== variant) {
    t5 = getMarketplaceContainerClass(variant, compact);
    $[42] = compact;
    $[43] = variant;
    $[44] = t5;
  } else {
    t5 = $[44];
  }
  const t6 = `${t5} tw-relative`;
  let t7;
  if ($[45] !== mediaMimeType || $[46] !== mediaUrl || $[47] !== resolvedPreviewHref) {
    t7 = <MarketplaceItemPreviewMediaLink mediaMimeType={mediaMimeType} mediaUrl={mediaUrl} resolvedPreviewHref={resolvedPreviewHref} />;
    $[45] = mediaMimeType;
    $[46] = mediaUrl;
    $[47] = resolvedPreviewHref;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  const t8 = priceCurrencyText || undefined;
  let t9;
  if ($[49] !== ctaAriaLabel || $[50] !== displayTitle || $[51] !== hasPrice || $[52] !== hideActions || $[53] !== href || $[54] !== marketplaceBrand || $[55] !== priceValueText || $[56] !== resolvedPreviewHref || $[57] !== t8) {
    t9 = <MarketplaceFullFooter href={href} resolvedPreviewHref={resolvedPreviewHref} displayTitle={displayTitle} ctaAriaLabel={ctaAriaLabel} hideActions={hideActions} hasPrice={hasPrice} priceValueText={priceValueText} priceCurrencyText={t8} marketplaceBrand={marketplaceBrand} />;
    $[49] = ctaAriaLabel;
    $[50] = displayTitle;
    $[51] = hasPrice;
    $[52] = hideActions;
    $[53] = href;
    $[54] = marketplaceBrand;
    $[55] = priceValueText;
    $[56] = resolvedPreviewHref;
    $[57] = t8;
    $[58] = t9;
  } else {
    t9 = $[58];
  }
  let t10;
  if ($[59] !== t6 || $[60] !== t7 || $[61] !== t9) {
    t10 = <div className={t6} data-testid="manifold-item-card">{t7}{t9}</div>;
    $[59] = t6;
    $[60] = t7;
    $[61] = t9;
    $[62] = t10;
  } else {
    t10 = $[62];
  }
  let t11;
  if ($[63] !== href || $[64] !== t10 || $[65] !== variant) {
    t11 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t10}</LinkPreviewCardLayout>;
    $[63] = href;
    $[64] = t10;
    $[65] = variant;
    $[66] = t11;
  } else {
    t11 = $[66];
  }
  return t11;
}